import React, { useEffect } from 'react';

const Rain: React.FC = () => {
  useEffect(() => {
    const createRaindrops = () => {
      const frontRow = document.querySelector('.rain.front-row') as HTMLElement;
      const backRow = document.querySelector('.rain.back-row') as HTMLElement;
      
      if (!frontRow || !backRow) return;

      frontRow.innerHTML = '';
      backRow.innerHTML = '';

      const createDrops = (container: HTMLElement, count: number, isBack: boolean) => {
        for (let i = 0; i < count; i++) {
          const drop = document.createElement('div');
          drop.className = 'drop';
          drop.style.left = `${Math.random() * 100}%`;
          drop.style.animationDuration = `${0.5 + Math.random() * 0.3}s`;
          drop.style.animationDelay = `${Math.random() * 2}s`;
          drop.style.opacity = isBack ? '0.3' : '0.7';
          container.appendChild(drop);
        }
      };

      createDrops(frontRow, 50, false);
      createDrops(backRow, 30, true);
    };

    createRaindrops();
    const interval = setInterval(createRaindrops, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="rain front-row"></div>
      <div className="rain back-row"></div>
    </>
  );
};

export default Rain; 